module.exports = __webpack_public_path__ + "static/img/zhengjian.9b74f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengjian.png
// module id = ncGq
// module chunks = 1